import React, { Component } from 'react';  
import echarts from 'echarts/lib/echarts';
// 引入柱状图
// import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/legend';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import Util from "../../util.js";
function compare(prop){
    // return function(a,b){
    //     var allStartDate = getDateS(a[property]);   
    //     var allEndDate = getDateS(b[property]);
    //     var value1 = allStartDate.getTime()
    //     var value2 = allEndDate.getTime()
    //     return value2 - value1;
    // }
    return function (obj1, obj2) {
      var val1 = obj1[prop];
      var val2 = obj2[prop];
      if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
      }
      if (val1 > val2) {
          return -1;
      } else if (val1 < val2) {
          return 1;
      } else {
          return 0;
      }            
    }
}

export default class RiskEvaluationPie extends Component {  
  componentDidMount() {
    let { dataSource } = this.props;
    let newArray = []
    let option;
    let colorArr = [];
    let newDataSource = Util.deepClone(dataSource.content.superFundItemViews);

    for(let i = 0; i < newDataSource.length; i++) {
     for(let k = i+1; k < newDataSource.length; k++) {
      if(newDataSource[i].typeName==newDataSource[k].typeName) {
        newDataSource[i].rate=Number(newDataSource[i].rate)+Number(newDataSource[k].rate);
        newDataSource.splice(k, 1);
        k--;
      }
     }
    }
    newDataSource.sort(compare("rate"));
    for (let i = 0; i < newDataSource.length; i++) {
      newArray.push({value: (newDataSource[i].rate*100).toFixed(2), name: newDataSource[i].typeName+(newDataSource[i].rate*100).toFixed(2)+"%"});
      if(newDataSource[i].fundType && newDataSource[i].fundType.indexOf("跨境权益") != -1){
        colorArr.push("#4729c5")
      }else if(newDataSource[i].fundType && newDataSource[i].fundType.indexOf("国内权益") != -1){
        colorArr.push("#e22424")
      }else if(newDataSource[i].fundType && newDataSource[i].fundType.indexOf("跨境债券") != -1){
        colorArr.push("#f25a0f")
      }else if(newDataSource[i].fundType && newDataSource[i].fundType.indexOf("另类") != -1){
        colorArr.push("#f0d331")
      }else if(newDataSource[i].fundType && newDataSource[i].fundType.indexOf("货币") != -1){
        colorArr.push("#23c7e2")
      }else if(newDataSource[i].fundType && newDataSource[i].fundType.indexOf("国内债券") != -1){
        colorArr.push("#034ab2")
      }
      if(i == newDataSource.length - 1) {
        option = {
            animation: window.isLess47,
            calculable : true,
            legend: {
                bottom: 15,
                x: 'center',
                orient:'horizontal',
                data:newArray,
                height: 20,
                width: window.winWidth-26,
                itemWidth:14,
                selectedMode:false,
                textStyle:{}
            },
            series : [
                {
                    type:'pie',
                    hoverAnimation:false,
                    radius : [45, 90],
                    center : [(window.winWidth-26)/2, 120],
                    roseType : 'radius',
                    data: newArray,
                  label:{
                    normal:{
                      show:false
                    }
                  },
                  labelLine:{
                    normal:{
                      show:false
                    }
                  },

                }
            ],
            color: colorArr
        };
        var myChart = echarts.init(document.getElementById('echartBox'), null, {renderer: 'svg'});
        // 绘制图表
        myChart.setOption(option);
      }
    }
  }

  render() {
    let { dataSource } = this.props;
    return (  
      <div style={{backgroundColor: "rgba(242,245,247,1)", paddingLeft: 13, paddingRight: 13, height: "100%", width: "100%"}}>  
        <div style={{width: "100%", height: "100%", position: "relative"}}>
            <div style={{backgroundColor: "transparent", position:'absolute', top: 100, width: window.winWidth - 26, textAlign: "center"}}>
              {
                dataSource.content.riskRankName == "积极型" ? <img style={{width: 48, height: 48}} src={require('../../img/jjPie.png')} /> :
                dataSource.content.riskRankName == "稳健型" ? <img style={{width: 48, height: 48}} src={require('../../img/wjPie.png')} /> :
                <img style={{width: 48, height: 48}} src={require('../../img/jhPie.png')} />
              }
            </div>
            <div id="echartBox" style={{width: window.winWidth - 26, height: 320}} />
        </div>
      </div>  
    );  
  }  
}  





// WEBPACK FOOTER //
// ./src/components/recommend/RiskEvaluationPie.js